import type { ComponentPropsWithoutRef, FunctionComponent } from 'react'
import React from 'react'

import { AnimationWrapper } from '../../AnimationWrapper'
import { BaseLink } from '../../Links'
import type { PictureProps } from '../../Picture'
import { Picture } from '../../Picture'
import { DateTime } from '../../Seatbelt2/BuildingBlocks/DateTime/DateTime'
import { TypographyV2 } from '../../Seatbelt2/Foundations/Typography'
import styles from './SmallHorizontalArticleCard.module.scss'

export const SmallHorizontalArticleCard: FunctionComponent<
  SmallHorizontalArticleCardProps
> = ({ date, href, image, title, ...rest }) => (
  <BaseLink href={href} invertedUnderline={true} {...rest}>
    <div
      className={styles.smallHorizontalArticleCard}
      data-testid="small-horizontal-article-card"
    >
      {image && (
        <Picture
          className={styles.smallHorizontalArticleCardPicture}
          aspectRatioMain={'two-to-one'}
          aspectRatioSm={'one-to-one'}
          {...image}
        />
      )}
      <div>
        <TypographyV2
          tag="h2"
          className={styles.smallHorizontalArticleCardTitle}
          textStyle="sb-text-body-default-strong"
        >
          <AnimationWrapper inverted={true}>{title}</AnimationWrapper>
        </TypographyV2>
        {date && (
          <div
            className={styles.smallHorizontalArticleCardDate}
            data-testid="small-horizontal-card-text-date"
          >
            <DateTime dateInput={date} showDateOrTime={'Date'} />
          </div>
        )}
      </div>
    </div>
  </BaseLink>
)

///////// IMPLEMENTATION /////////

export type SmallHorizontalArticleCardProps = {
  date?: string
  href: string
  image?: PictureProps
  title: string
} & Omit<ComponentPropsWithoutRef<typeof BaseLink>, 'children'>
